angular.module('bbl.directives.dashboard-audio-player', []);

require('./dashboard-audio-player.directive');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard-audio-player/index.js
 ** module id = 340
 ** module chunks = 0
 **/